import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PageHeader from './PageTabs'
import Header from './Header'
import Footer from './Footer'
// import { GlobalProvider } from '../component/GlobalContext';
// import { GlobalProvider } from "./GlobalContext";


const WithHeaderFooterAndMenu = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/";
  const [rightContentExpanded, setRightContentExpanded] = useState(false);

  const handleRightContentClick = (expanded) => {
    setRightContentExpanded(expanded);
  };

  return (
    <>
        {/* <GlobalProvider> */}
          <div className="admin-layout">
            <Header/>
            <PageHeader/>
                <div className="admin-content">{children}</div>
            <Footer/>
          </div>
        {/* </GlobalProvider> */}
    </>
  );
};

export default React.memo(WithHeaderFooterAndMenu);
